// extracted by mini-css-extract-plugin
module.exports = {"disabled":"OrderHistoryTable_disabled__3R9HH"};